import React from "react";
import { NavLink } from "react-router-dom";

const Navlinks = ({ links, isAdmin = false }) => {
  
  return (
    <div className="flex flex-col lg:flex-row items-start justify-start gap-8  ">
      {links.map((link, index) => {
        const Icon = link.icon;
        return (
          <NavLink
            className={({ isActive }) =>
              isActive
                ? ` flex text-white ${
                    isAdmin
                      ? "flex-row justify-items-center lg:flex-col lg:gap-0.5"
                      : "flex-row"
                  } items-center text-md gap-2 font-semibold tabActiveColor text-left`
                : ` flex text-white ${
                    isAdmin ? "flex-row lg:flex-col lg:gap-0.5" : "flex-row"
                  } items-center text-md gap-2 font-semibold  hover:tabActiveColor text-left`
            }
            to={link.path}
            key={index}
          >
            <Icon className="h-4 w-4" strokeWidth={2.5} />
            <span>{link.label}</span>
          </NavLink>
        );
      })}
    </div>
  );
};

export default Navlinks;
